import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ComponentSetupService } from 'formbird-sc-shared';
import { ChangedDocumentService, FormbirdInjectorService, ClientConstants } from 'formbird-services';
import { Subscription } from 'rxjs';
import { isEqual } from 'lodash';
import { AbstractControl, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { AddressDetails } from '../AddressDetails';

@Component({
  selector: 'street-data',
  templateUrl: './street-data.component.html',
  styleUrls: [
    './street-data.component.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class StreetDataComponent implements OnInit, OnChanges, AfterViewInit {
  formControlUnitNo: AbstractControl;
  formControlStreetNo: AbstractControl;
  formControlStreetName: AbstractControl;
  formControlSuburb: AbstractControl;
  formControlState: AbstractControl;
  formControlCountry: AbstractControl;
  formControlPostcode: AbstractControl;
  formControlLocationDescription: AbstractControl;

  @Input() disabled;
  @Input() keyName;
  @Input() isParentReady: any;
  @Input() fieldName: any;
  @Input() template: any;
  @Input() registeredControlName: any;
  @Input() parentComponent: any;
  @Input() disableAddress: any;
  @Input() get streetDataStr() {
    return this.strStreetData;
  }

  @Output() evtInit: EventEmitter<any> = new EventEmitter<any>();
  @Output() evtSetStreetDataStr = new EventEmitter();
  @Output() evtPropertyValueChange = new EventEmitter();
  @Output() evtValueChangedAddress = new EventEmitter();
  @Output() evtCoordinateValueChange = new EventEmitter();

  // street data
  @ViewChild('eUnitNo', {static: false}) eUnitNo: ElementRef;
  @ViewChild('eStreetNo', {static: false}) eStreetNo: ElementRef;
  @ViewChild('eStreetName', {static: false}) eStreetName: ElementRef;
  @ViewChild('eSuburbTown', {static: false}) eSuburbTown: ElementRef;
  @ViewChild('eState', {static: false}) eState: ElementRef;
  @ViewChild('eCountry', {static: false}) eCountry: ElementRef;
  @ViewChild('ePostCode', {static: false}) ePostCode: ElementRef;
  @ViewChild('eLocationDescription', {static: false}) eLocationDescription: ElementRef;
  @ViewChild('eLatitude', {static: false}) eLatitude: ElementRef;
  @ViewChild('eLongitude', {static: false}) eLongitude: ElementRef;

  
  set streetDataStr(value) {
    this.strStreetData = value;
    if (!this.streetData[this.keyName]) {
      this.streetData[this.keyName] = {};
    }
    try {
      this.streetData[this.keyName] = JSON.parse(this.strStreetData);
    } catch (err) {
      this.streetData[this.keyName] = null;
    }
    this.evtSetStreetDataStr.emit();
    this.cdRef.detectChanges();
  }

  private strStreetData = '';
  streetData;
  disableMandatory = false;
  disableCoordinate = false;
  isReady;
  checkMapReadyCount = 0;
  previousValidCoors = ['', ''];
  subs: Subscription = new Subscription();
  isReadOnly = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private componentSetupService: ComponentSetupService,
    private changedDocumentService: ChangedDocumentService,
  ) {
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
  ngOnInit() {
    this.streetData = {};
    this.streetData[this.keyName] = new AddressDetails();

    this.checkReadOnly();

    this.setupControls();
    this.setupChangeDetection();

    this.initialize();
  }

  ngAfterViewInit() {
  }

  ngOnChanges(changes: any) {
  }

  getDisplayFn() {
    return (val) => val ? val.street : val;
  }


  initialize() {
    this.evtInit.emit({ streetDataComp: this });

    // 15295
    this.watchFieldChange();

  }

  setupControls() {
    this.formControlUnitNo = this.componentSetupService.setupControl(this.parentComponent
      , this.registeredControlName + '_unitNo'
      , this.streetData[this.keyName]?.properties?.unitNo ?
       this.streetData[this.keyName]?.properties?.unitNo : ''
      , null);

    this.formControlStreetNo = this.componentSetupService.setupControl(this.parentComponent
      , this.registeredControlName + '_streetNo'
      , this.streetData[this.keyName]?.properties?.streetNo ?
        this.streetData[this.keyName]?.properties?.streetNo : ''
      , null);

    this.formControlStreetName = this.componentSetupService.setupControl(this.parentComponent
      , this.registeredControlName + '_streetName'
      , this.streetData[this.keyName]?.properties?.street ?
        this.streetData[this.keyName]?.properties?.street : ''
      , null);

    this.formControlSuburb = this.componentSetupService.setupControl(this.parentComponent
      , this.registeredControlName + '_suburb'
      , this.streetData[this.keyName]?.properties?.suburb ?
        this.streetData[this.keyName]?.properties?.suburb : ''
      , null);

    this.formControlState = this.componentSetupService.setupControl(this.parentComponent
      , this.registeredControlName + '_state'
      , this.streetData[this.keyName]?.properties?.state ?
        this.streetData[this.keyName]?.properties?.state : ''
      , null);

    this.formControlCountry = this.componentSetupService.setupControl(this.parentComponent
      , this.registeredControlName + '_country'
      , this.streetData[this.keyName]?.properties?.country ?
        this.streetData[this.keyName]?.properties?.country : ''
      , null);

    this.formControlPostcode = this.componentSetupService.setupControl(this.parentComponent
      , this.registeredControlName + '_postcode'
      , this.streetData[this.keyName]?.properties?.postcode ?
        this.streetData[this.keyName]?.properties?.postcode : ''
      , null);

    this.formControlLocationDescription = this.componentSetupService.setupControl(this.parentComponent
      , this.registeredControlName + '_locationDescription'
      , this.streetData[this.keyName]?.properties?.locationDescription ?
        this.streetData[this.keyName]?.properties?.locationDescription : ''
      , null);
  }

  setupChangeDetection() {
    const subUnitNo = this.formControlUnitNo.valueChanges.pipe(debounceTime(ClientConstants.VALIDATION_INTERVAL_TIME))
      .subscribe(value => {
        this.valueChangedAddress('unitNo', value);
    });
    this.subs.add(subUnitNo);

    const subStreetNo = this.formControlStreetNo.valueChanges.pipe(debounceTime(ClientConstants.VALIDATION_INTERVAL_TIME))
      .subscribe(value => {
        this.valueChangedAddress('streetNo', value);
    });
    this.subs.add(subStreetNo);

    const subStreetName = this.formControlStreetName.valueChanges.pipe(debounceTime(ClientConstants.VALIDATION_INTERVAL_TIME))
      .subscribe(value => {
        this.valueChangedAddress('streetName', value);
    });
    this.subs.add(subStreetName);

    const subSuburb = this.formControlSuburb.valueChanges.pipe(debounceTime(ClientConstants.VALIDATION_INTERVAL_TIME))
      .subscribe(value => {
        this.valueChangedAddress('suburb', value);
    });
    this.subs.add(subSuburb);

    const subState = this.formControlState.valueChanges.pipe(debounceTime(ClientConstants.VALIDATION_INTERVAL_TIME))
      .subscribe(value => {
        this.valueChangedAddress('state', value);
    });
    this.subs.add(subState);

    const subCountry = this.formControlCountry.valueChanges.pipe(debounceTime(ClientConstants.VALIDATION_INTERVAL_TIME))
      .subscribe(value => {
        this.valueChangedAddress('country', value);
    });
    this.subs.add(subCountry);

    const subPostcode = this.formControlPostcode.valueChanges.pipe(debounceTime(ClientConstants.VALIDATION_INTERVAL_TIME))
      .subscribe(value => {
        this.valueChangedAddress('postcode', value);
    });
    this.subs.add(subPostcode);

    const subLocationDescription = this.formControlLocationDescription.valueChanges.pipe(debounceTime(ClientConstants.VALIDATION_INTERVAL_TIME))
      .subscribe(value => {
        this.valueChangedAddress('locationDescription', value);
    });
    this.subs.add(subLocationDescription);
  }
  valueChangedAddress (type, $event) {
    // console.log(`**** valueChangedAddress, type = ${type}`
    //  + `\n\t BEFORE, streetDate = ${JSON.stringify(this.streetData[this.keyName])}`);
    let hasChange = true;
    switch(type) {
      case 'unitNo':
        this.streetData[this.keyName].properties.unitNo = this.formControlUnitNo.value;
        break;
      case 'streetNo':
        this.streetData[this.keyName].properties.streetNo = this.formControlStreetNo.value;
        break;
      case 'streetName':
        this.streetData[this.keyName].properties.street = this.formControlStreetName.value;
        break;
      case 'suburb':
        this.streetData[this.keyName].properties.suburb = this.formControlSuburb.value;
        break;
      case 'state':
        this.streetData[this.keyName].properties.state = this.formControlState.value;
        break;
      case 'country':
        this.streetData[this.keyName].properties.country = this.formControlCountry.value;
        break;
      case 'postcode':
        this.streetData[this.keyName].properties.postcode = this.formControlPostcode.value;
        break;
      case 'locationDescription':
        this.streetData[this.keyName].properties.locationDescription = this.formControlLocationDescription.value;
        break;
      default:
        hasChange = false;
        break;
    }

    if (hasChange) {
      // console.log(`**** hasChange = ${hasChange}`
      // + `\n\t AFTER, streetDate = ${JSON.stringify(this.streetData[this.keyName])}`);
      this.streetDataStr = JSON.stringify(this.streetData[this.keyName]);
      this.evtValueChangedAddress.emit();
    }
    
  }

  
  watchFieldChange() {
    const compSub = this.changedDocumentService.watchComponentDef(this.fieldName, this.template.documentId).subscribe(componentDefinition => {
      this.disabled = componentDefinition?.enabled === false;
      this.disableAddress = componentDefinition?.disableAddress;
      this.checkReadOnly();

      this.cdRef.detectChanges();
    });
    this.subs.add(compSub);
  }

  propertyValueChange(event, name) {
    const st = this.streetData[this.keyName];
    if (st === null || st === 'undefined') { return; }
    const value = event.target.value;
    if (!isEqual(st.properties[name], value)) {
      st.properties[name] = value;
      if ( !st.geometry || !st.geometry.coordinates || st.geometry.coordinates.length < 2
        || (st.geometry.coordinates[0] == 0 && st.geometry.coordinates[1] == 0)) { // condition to delete geometry
        console.log('delete geometry');
        delete st.geometry;
        this.previousValidCoors = ['', ''];
      }
      this.streetDataStr = JSON.stringify(st);
      this.evtPropertyValueChange.emit();
    }
  }
  coordinateValueChange(event, index) {
    const newValue = Number(event.target.value);
    const st = this.streetData[this.keyName];
    if (isNaN(newValue)) {
      console.log('typing invalid latitude');
      event.target.value = this.previousValidCoors[index];
      return;
    }

    if (st.geometry) {
      if (st.geometry.coordinates) {
        if (st.geometry.coordinates.length == 0) {
          if (event.target.value.trim().length == 0) {
            return;
          }
          st.geometry.coordinates = [0, 0]; // temprature init coordinate array
          this.previousValidCoors = ['0', '0'];
        }
      }
      else {
        st.geometry.coordinates = [0, 0];
        this.previousValidCoors = ['0', '0'];
      }
    } else {
      st.geometry = {
        type: 'Point',
        coordinates: [0, 0]
      };
      this.previousValidCoors = ['0', '0'];
    }
    if (!isEqual(st.geometry.coordinates[index], newValue)) {
      st.geometry.coordinates[index] = newValue;
      this.previousValidCoors[index] = event.target.value;

      // if user remove lat/lng then check both of them is 0 then remove geometry property
      if (event.target.value.trim.length == 0 && st.geometry && st.geometry.coordinates && st.geometry.coordinates.length > 1
        && st.geometry.coordinates[0] == 0 && st.geometry.coordinates[1] == 0 ) { // condition to delete geometry
        console.log('delete geometry');
        const st = this.streetData[this.keyName];
        delete st.geometry;
        this.previousValidCoors = ['', ''];
      }
      this.streetDataStr = JSON.stringify(st);
      this.evtCoordinateValueChange.emit();
    }

  }

  bindStreetData(hideAddress) {
    if (hideAddress === true || !this.streetData[this.keyName]) { // 14328#c59386: 2
      return;
    }
    
    if (this.streetData[this.keyName].properties ) {
      if (this.streetData[this.keyName].properties.unitNo ) {
        this.eUnitNo.nativeElement.value = this.streetData[this.keyName].properties.unitNo;
      } else {
        this.eUnitNo.nativeElement.value = '';
      }
      if (this.streetData[this.keyName].properties.streetNo) {
        this.eStreetNo.nativeElement.value = this.streetData[this.keyName].properties.streetNo;
      } else {
        this.eStreetNo.nativeElement.value = '';
      }

      if (this.streetData[this.keyName].properties.street) {
        this.eStreetName.nativeElement.value = this.streetData[this.keyName].properties.street;
      } else {
        this.eStreetName.nativeElement.value = '';
      }
      if (this.streetData[this.keyName].properties.suburb) {
        this.eSuburbTown.nativeElement.value = this.streetData[this.keyName].properties.suburb;
      } else {
        this.eSuburbTown.nativeElement.value = '';
      }
      if (this.streetData[this.keyName].properties.state) {
        this.eState.nativeElement.value = this.streetData[this.keyName].properties.state;
      } else {
        this.eState.nativeElement.value = '';
      }
      if (this.streetData[this.keyName].properties.country) {
        this.eCountry.nativeElement.value = this.streetData[this.keyName].properties.country;
      } else {
        this.eCountry.nativeElement.value = '';
      }
      if (this.streetData[this.keyName].properties.postcode) {
        this.ePostCode.nativeElement.value = this.streetData[this.keyName].properties.postcode;
      } else {
        this.ePostCode.nativeElement.value = '';
      }
      if (this.streetData[this.keyName].properties.locationDescription) {
        this.eLocationDescription.nativeElement.value = this.streetData[this.keyName].properties.locationDescription;
      } else {
        this.eLocationDescription.nativeElement.value = '';
      }
    }

    if ( this.streetData[this.keyName].geometry && this.streetData[this.keyName].geometry.coordinates.length === 2) {
      this.eLatitude.nativeElement.value = this.streetData[this.keyName].geometry.coordinates[1];
      this.eLongitude.nativeElement.value = this.streetData[this.keyName].geometry.coordinates[0];
    } else {
      this.eLatitude.nativeElement.value = '';
      this.eLongitude.nativeElement.value = '';
    }

    this.previousValidCoors = [this.eLongitude.nativeElement.value, this.eLatitude.nativeElement.value];
  }

  checkReadOnly() {
    if (this.disableAddress === true) {
      this.isReadOnly = true; // `disableAddress` overrides all and sets `readonly` to true
      console.log(`**** this.isReadOnly = ${this.isReadOnly}`);
      return;
    }
    this.isReadOnly = this.disabled || this.disableMandatory;
    console.log(`**** this.isReadOnly 2 = ${this.isReadOnly}`);
  }
}
